import { Link, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { usePortal } from '../lib/portal';
import { Card } from './ui';

/**
 * Posting needs an account (specification §11).
 *
 * Shown INSTEAD of the form, not after it. The alternative — let somebody fill
 * in nine fields and then answer 401 — throws away their work at the moment
 * they were most willing to give it, and reads as a failure rather than as a
 * step. Asking first costs one click and loses nothing.
 *
 * §11 requires the account and says to keep sign-up free; this says both, and
 * says what the account is for, because "sign up to continue" with no reason
 * given is how forms get abandoned.
 */
export function PostingGate({ what, children }: { what: string; children: ReactNode }) {
  const { isAuthenticated } = usePortal();
  const { pathname } = useLocation();

  if (isAuthenticated) return <>{children}</>;

  return (
    <Card title={`Sign in to ${what}`}>
      <p style={{ marginTop: 0 }}>
        Listing on NyumbaSuite is free, and needs an account so you can come back to
        what you posted, see whether it has been approved, and take it down when you
        are done.
      </p>
      <div className="row" style={{ gap: 12, flexWrap: 'wrap' }}>
        <Link className="btn btn-primary" to="/services/signup">Create a free account</Link>
        {/* The form they were heading for, remembered, so signing in returns
            them to it rather than to a dashboard they did not ask for. */}
        <Link className="btn btn-secondary" to="/login" state={{ from: pathname }}>
          I already have one
        </Link>
      </div>
      <p className="muted" style={{ marginBottom: 0, marginTop: 16 }}>
        Already run property on NyumbaSuite? Sign in with that account — you can list a
        service or sell something without creating a second one.
      </p>
    </Card>
  );
}
